import Areas from '@src/main/ui/components/Areas/Areas';
import { type FC } from 'react';

const AreasPage: FC = () => <Areas />;

export default AreasPage;
